import { render, staticRenderFns } from "./date.vue?vue&type=template&id=264a69dc&scoped=true&"
import script from "./date.vue?vue&type=script&lang=js&"
export * from "./date.vue?vue&type=script&lang=js&"
import style0 from "./date.vue?vue&type=style&index=0&id=264a69dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264a69dc",
  null
  
)

export default component.exports